import { render, staticRenderFns } from "./Oidc.vue?vue&type=template&id=4624b5e5&"
import script from "./Oidc.vue?vue&type=script&lang=js&"
export * from "./Oidc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports